<template>
    <BaseBoxColor 
        variant="gray" 
        class="w-full flex flex-col p-4 gap-2 hover-selectable" 
        :class="{'border border-primary': props.selected}"
    >
        <div class="flex items-center gap-4 flex-wrap">
            <h3>{{ props.session.channelType }}</h3>
            <h6 class="text-white/75 break-all">{{ props.session.sessionId }}</h6>
        </div>
        <div class="flex flex-col gap-2" style="margin: 0px;">
            <div class="flex flex-col">
                <h6 class="text-white/75">{{t("user")}}</h6>
                <strong>{{ formattedUser }}</strong>
            </div>
            <div class="flex">
                <div class="flex flex-col flex-1">
                    <h6 class="text-white/75">{{ t("messages") }}</h6>
                    <strong>{{ messages }}</strong>
                </div>
                <div class="flex flex-col flex-1">
                    <h6 class="text-white/75">{{ t("firstMessage") }}</h6>
                    <strong>{{ formattedStart }}</strong>
                </div>
                <div class="flex flex-col flex-1">
                    <h6 class="text-white/75">{{ t("lastMessage") }}</h6>
                    <strong>{{ formattedEnd }}</strong>
                </div>
            </div>
        </div>
    </BaseBoxColor>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from "vue-i18n";
import { DateTime } from "luxon";

const { t } = useI18n();
const props = defineProps({
    session: {
        type: Object
    },
    selected: {
        type: Boolean,
        default: false
    }
})

const formattedUser = computed(() => resolveUsername(props.session.user))
const formattedStart = computed(() => dateFormatter(props.session.start))
const formattedEnd = computed(() => dateFormatter(props.session.end))
const messages = computed(() => props.session.history.length)

const resolveUsername = (user) => {
    if(!user || !user.username.trim()) return t("anonymous")
    return user.username
}

const dateFormatter = (date) => {
    return DateTime.fromISO(date).toFormat("dd/MM/yyyy")
}

</script>